import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/purple-ventures/src/components/landing/sections/FooterSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/purple-ventures/src/components/landing/sections/Header.tsx");
